export enum AdminRole {
  SuperAdmin = 'Super Admin',
  Admin = 'Admin',
  BasicPlus = 'Basic Plus',
  Basic = 'Basic'
}
